import { render, staticRenderFns } from "./BerlianTersediaCabangView.vue?vue&type=template&id=5ab2cca6&scoped=true&"
import script from "./BerlianTersediaCabangView.vue?vue&type=script&lang=js&"
export * from "./BerlianTersediaCabangView.vue?vue&type=script&lang=js&"
import style0 from "./BerlianTersediaCabangView.vue?vue&type=style&index=0&id=5ab2cca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab2cca6",
  null
  
)

export default component.exports